import React from 'react';

import { Box, Typography } from '@material-ui/core';

import { DRCStatus } from '@vyce/core/src/types';
import { DRC_REASON_LABELS } from '@vyce/core/src/constants';

import { useStyles } from '../styles';

interface Props {
  status: DRCStatus | null;
}

/**
 * Everything currently standing between this worker and the reverse charge. The server sends
 * the blockers in a fixed order, so the list reads as "what to fix next" top to bottom.
 */
export const DRCBlockersList: React.FC<Props> = ({ status }) => {
  const classes = useStyles();

  if (!status || status.applies || !status.blockers.length) {
    return null;
  }

  return (
    <Box marginTop={2}>
      <Typography className={classes.sectionLabel}>To make the reverse charge apply</Typography>
      <Box component="ul" className={classes.blockersList} marginTop={1}>
        {status.blockers.map(blocker => (
          <Typography component="li" variant="body2" color="textSecondary" key={blocker}>
            {DRC_REASON_LABELS[blocker]}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
